<template>
    <Dialog :common-dialog="dialog" :dialog-width="dialogWidth">
        <template v-slot:title>
            Recurring({{ OriginalScheduleData?.length || 0 }})
        </template>

        <template v-slot:body>
            <v-container>
                <v-form ref="schedule-auto-generated-form" lazy-validation>
                    <table width="100%">
                        <thead>
                            <tr class="custom-border-bottom">
                                <td class="font-size-16 font-weight-700">S No.</td>
                                <td class="font-size-16 font-weight-700">Start Date</td>
                                <td class="font-size-16 font-weight-700">Day</td>
                                <td class="font-size-16 font-weight-700">Start Time</td>
                                <td class="font-size-16 font-weight-700">End Time</td>
                                <td class="font-size-16 font-weight-700">Status</td>
                            </tr>
                        </thead>
                        <tr v-for="(row, index) in OriginalScheduleData" :key="index"
                            :class="{ 'visit-row-hover': row.isEdited }">
                            <!-- Primary Checkbox -->
                            <td align="left" valign="middle">
                                {{ index + 1 }}.
                            </td>

                            <!-- Start Date -->
                            <td>
                                <DatePicker v-model="row.startDate" key="visit-show-schedule-start-date"
                                    id="visit-show-schedule-start-date" readonly :min-date="todayDate"
                                    placeholder="Start Date" />

                            </td>

                            <!-- Day -->
                            <td>
                                <v-text-field readonly solo flat dense :disabled="!row.status" filled hide-details
                                    :value="row.daysOfWeek"></v-text-field>
                            </td>

                            <!-- Start Time -->
                            <td>
                                <TimePicker v-model="row.startTime" key="visit-show-schedule-start-time"
                                    id="visit-show-schedule-start-time" placeholder="Start Time" />
                            </td>
                            <td>
                                <TimePicker v-model="row.endTime" key="visit-show-schedule-end-time"
                                    id="visit-show-schedule-end-time" placeholder="End Time" />
                            </td>
                            <td align="center" valign="middle">
                                <v-switch class="m-0 p-0" color="cyan" dense hide-details :false-value="0"
                                    :true-value="1" v-model="row.status" inset></v-switch>
                            </td>
                        </tr>
                    </table>
                </v-form>
            </v-container>
        </template>

        <template v-slot:action>
            <v-btn class="mx-2 custom-grey-border custom-bold-button white--text" color="cyan"
                @click="validateSchedule">
                Save
            </v-btn>
            <v-btn class="mx-2 custom-grey-border custom-bold-button" @click="$emit('close', true)">
                Close
            </v-btn>
        </template>
    </Dialog>

</template>
<script>
import TimePicker from "@/view/components/TimePicker.vue";
import { forEach } from "lodash";
import moment from "moment-timezone";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { SET_RECURRING_DATE } from "@/core/services/store/job.module";
import DatePicker from "@/view/components/QDatePicker.vue";

import Dialog from "@/view/pages/partials/Dialog.vue";
export default {
    data() {
        return {
            dialogWidth: '800px',
            todayDate: moment(new Date()).format("YYYY-MM-DD"),
        };

    },
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        OriginalScheduleData:
        {
            type: [Array, Object],
            default: null,
        }
    },

    components: {
        Dialog, DatePicker, TimePicker
    },
    methods:
    {
        validateSchedule() {
            let checkValidation = true;
            forEach(this.OriginalScheduleData, (schedule, index) => {
                if (schedule.startTime && schedule.endTime) {
                    let starttime = moment(schedule.startTime, "hh:mm A");
                    let endtime = moment(schedule.endTime, "hh:mm A");
                    if (starttime.isAfter(endtime) || starttime.isSame(endtime)) {
                        ErrorEventBus.$emit(
                            "update:error",
                            InitializeError(
                                ` Row (${index + 1}) End Time must be after Start Time.`
                            )
                        );
                        checkValidation = false;
                        return false;
                    }
                }
            });
            if (checkValidation) {
                this.$store.commit(SET_RECURRING_DATE, this.OriginalScheduleData);
                this.$emit("next", true);
            }
        }
    }

}
</script>